import { render, staticRenderFns } from "./Comment_m.vue?vue&type=template&id=b337174c&scoped=true"
import script from "./Comment_m.vue?vue&type=script&lang=js"
export * from "./Comment_m.vue?vue&type=script&lang=js"
import style0 from "./Comment_m.vue?vue&type=style&index=0&id=b337174c&prod&lang=css"
import style1 from "./Comment_m.vue?vue&type=style&index=1&id=b337174c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b337174c",
  null
  
)

export default component.exports